export default {
  name: 'Home',
}
